import Axios from "@/plugins/Axios";

export class PlanosSemestraisInfantilService {
  async planoSemestral(gestaoDeAulaId, semestre, disciplinaId) {
    const response = await Axios().get(
      `planos-semestrais-infantil/plano-semestral/${gestaoDeAulaId}/${semestre}?disciplinaId=${disciplinaId}`
    );
    return response.data;
  }

  async createOrUpdate(plano) {
    const response = await Axios().post(`planos-semestrais-infantil/criar-plano-semestral`, {
      plano,
    });
    return response.data;
  }
}

export default new PlanosSemestraisInfantilService();
